import React from 'react';
import { IconButton, Theme } from '@mui/material';

type Props = {
  expanded: boolean;
  onExpand: () => void;
  onCollapse: () => void;
  disabled?: boolean;
  size?: number;
};

const ChevronDownIcon: React.FC<{ size: number }> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.294 13.4197C10.1313 13.5824 9.86744 13.5824 9.70472 13.4197L3.45472 7.16971C3.292 7.00699 3.292 6.74317 3.45472 6.58045C3.61744 6.41773 3.88126 6.41773 4.04398 6.58045L9.99935 12.5358L15.9547 6.58045C16.1174 6.41773 16.3813 6.41773 16.544 6.58045C16.7067 6.74317 16.7067 7.00699 16.544 7.16971L10.294 13.4197Z"
      fill="currentColor"
    />
  </svg>
);

const ExpandChevronButton: React.FC<Props> = ({
  expanded,
  onExpand,
  onCollapse,
  disabled = false,
  size = 20,
}) => (
  <IconButton
    onClick={expanded ? onCollapse : onExpand}
    disabled={disabled}
    size="small"
    sx={(theme: Theme) => ({
      '&:hover': { background: 'none' },
      transition: theme.transitions.create(['transform'], {
        duration: theme.transitions.duration.standard,
      }),
      transform: expanded ? 'rotate(0deg)' : 'rotate(-180deg)',
      color: theme.palette.grey[400],
    })}
  >
    <ChevronDownIcon size={size} />
  </IconButton>
);

export default ExpandChevronButton;
